export class ConfigurationStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<ConfigurationStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<ConfigurationStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConfigurationStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
